export default "__VITE_ASSET__Dpf8xUco__"